<div *ngIf="((!(hasViewMoneyAccess$ | async) && (authorizedFinished$ | async)) || (authorizedFailed$ | async))" id="initiate-and-release-content">
    <mm-view-move-money-page></mm-view-move-money-page>
</div>
<div  *ngIf="(hasViewMoneyAccess$ | async)" id="initiate-and-release-content">
    <div *ngIf="(accountInContext || masterAccountInContext) else legacyRedirect;" id="initiate-and-release-content" data-testid="initiate-and-release-content">
        <div *ngIf="isInitiateAndReleaseFirm">
            <mm-account-info-header *ngIf="masterAccountInContext" [accountInfo]="accountInfo"></mm-account-info-header>
            <mm-account-info *ngIf="!masterAccountInContext"></mm-account-info>
            <mm-banners *ngIf="isServiceFailureBannerEnable"  [bannerText]="[serviceErrorMessage]" [type]="'error'"></mm-banners>
            <div *ngIf="(pageInContext$ | async) === 'input'">
                <mm-init-release-transactions-table [UserInContext]="userContext" (isDraftsServiceFailure)="isServiceFailure($event)"></mm-init-release-transactions-table>
                <sdps-divider *ngIf="this.isFsaUser" class="createRuleDivider" variation="secondary"></sdps-divider>
                <mm-init-release-create-rule-section *ngIf="this.isFsaUser"></mm-init-release-create-rule-section>
            </div>
            <div *ngIf="(pageInContext$ | async) === 'review'">
                <mm-review-page *ngIf="(typeInContext$ | async) === 'transaction'"></mm-review-page>
                <mm-standing-authorization-review-page *ngIf="(typeInContext$ | async) === 'standing-authorization'"></mm-standing-authorization-review-page>
            </div>
            <div *ngIf="(pageInContext$ | async) === 'confirmation'">
                <mm-confirmation-page *ngIf="(typeInContext$ | async) === 'transaction'"></mm-confirmation-page>
                <mm-standing-authorization-confirmation-page *ngIf="(typeInContext$ | async) === 'standing-authorization'"></mm-standing-authorization-confirmation-page>
            </div>
        </div>
        <div id="walkme" *ngIf="(pageInContext$ | async) === 'input' && !isInitiateAndReleaseFirm">
            <div id="section-header">How it Works</div>
        </div>
    </div>
</div>
<ng-template #legacyRedirect>
    <mm-legacy-redirect-landing-page></mm-legacy-redirect-landing-page>
</ng-template>